<div [ngStyle]="contentStyle" class="section pointer-events-none">
  <form
    class="beneficiary-form finxForm"
    [formGroup]="addBeneficiaryForm"
    (ngSubmit)="onAddBeneficiaryformSubmit()"
    [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}"
  >
    <div class="text-left">
      <div
        *ngIf="
          !enableBeneficiaryFirstAndLastName ||
          (enableBeneficiaryFirstAndLastName && beneficiaryType === ACCOUNTTYPE.BUSINESS)
        "
      >
        <finxone-input
          [type]="'text'"
          [name]="'name'"
          [label]="dataIn?.attri?.widgetProperties['recipientNameLabel']"
          formControlName="name"
          [formControlInvalid]="
            !!(addBeneficiaryForm.controls['name']?.invalid && addBeneficiaryForm.controls['name']?.touched)
          "
          [value]="addBeneficiaryForm.controls['name']?.value ?? ''"
          [validationConfig]="[
            {
              type: 'required',
              message: 'Field is mandatory'
            },
            {
              type: 'pattern',
              params: '^[A-Za-z\\s\-\.\’]+$',
              message: 'Only alphabetic characters, hyphens, apostrophes, and periods are allowed'
            }
          ]"
        >
        </finxone-input>
      </div>

      <div
        *ngIf="enableBeneficiaryFirstAndLastName && beneficiaryType === ACCOUNTTYPE.PERSONAL"
        class="finxForm"
        [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}"
      >
        <div class="">
          <finxone-input
            [type]="'text'"
            [name]="'firstName'"
            [label]="dataIn?.attri?.widgetProperties['firstNameLabel']"
            formControlName="firstName"
            [formControlInvalid]="
              !!(
                addBeneficiaryForm.controls['firstName']?.dirty &&
                addBeneficiaryForm.controls['firstName']?.invalid &&
                addBeneficiaryForm.controls['firstName']?.touched
              )
            "
            [value]="addBeneficiaryForm.controls['firstName']?.value ?? ''"
            [validationConfig]="[
              {
                type: 'required',
                message: 'Field is mandatory'
              },
              {
                type: 'pattern',
                params: '^[A-Za-z\\s\-\.\’]+$',
                message: 'Only alphabetic characters, hyphens, apostrophes, and periods are allowed'
              }
            ]"
          >
          </finxone-input>
        </div>
        <div>
          <finxone-input
            [type]="'text'"
            [name]="'lastName'"
            [label]="dataIn?.attri?.widgetProperties['lastNameLabel']"
            formControlName="lastName"
            [formControlInvalid]="
              !!(
                addBeneficiaryForm.controls['lastName']?.dirty &&
                addBeneficiaryForm.controls['lastName']?.invalid &&
                addBeneficiaryForm.controls['lastName']?.touched
              )
            "
            [value]="addBeneficiaryForm.controls['lastName']?.value ?? ''"
            [validationConfig]="[
              {
                type: 'required',
                message: 'Field is mandatory'
              },
              {
                type: 'pattern',
                params: '^[A-Za-z\\s\-\.\’]+$',
                message: 'Only alphabetic characters, hyphens, apostrophes, and periods are allowed'
              }
            ]"
          >
          </finxone-input>
        </div>
      </div>
    </div>

    <div class="text-left">
      <div>
        <finx-inputmask
          type="text"
          class="profile-input"
          formControlName="sortCode"
          mask="99-99-99"
          [label]="dataIn?.attri?.widgetProperties['sortCodeLabel']"
          [name]="'sortCode'"
        ></finx-inputmask>
      </div>

      <span
        *ngIf="
          addBeneficiaryForm.get('sortCode')?.touched &&
          addBeneficiaryForm.get('sortCode')?.hasError('minlength')
        "
        class="text-error typog-xs pt-2"
        data-error="sortCode"
      >
        Minimum 6 characters are required
      </span>
      <span
        *ngIf="
          addBeneficiaryForm.get('sortCode')?.touched &&
          addBeneficiaryForm.get('sortCode')?.hasError('maxlength')
        "
        class="text-error typog-xs pt-2"
        data-error="sortCode"
      >
        Maximum 6 characters are required
      </span>
      <span
        *ngIf="
          addBeneficiaryForm.get('sortCode')?.touched &&
          addBeneficiaryForm.get('sortCode')?.hasError('required')
        "
        class="text-error typog-xs pt-2"
        data-error="sortCode"
      >
        Field is mandatory
      </span>
      <span
        *ngIf="
          addBeneficiaryForm.get('sortCode')?.touched &&
          addBeneficiaryForm.get('sortCode')?.hasError('pattern')
        "
        class="text-error typog-xs pt-2"
        data-error="sortCode"
      >
        Invalid value for sort code
      </span>
    </div>

    <div class="text-left">
      <div>
        <finxone-input
          [type]="'number'"
          [name]="'accountNumber'"
          [label]="dataIn?.attri?.widgetProperties['accountNumberLabel']"
          formControlName="accountNumber"
          [formControlInvalid]="
            !!(
              addBeneficiaryForm.controls['accountNumber']?.dirty &&
              addBeneficiaryForm.controls['accountNumber']?.invalid &&
              addBeneficiaryForm.controls['accountNumber']?.touched
            )
          "
          [value]="addBeneficiaryForm.controls['accountNumber']?.value ?? ''"
          [validationConfig]="[
            {
              type: 'required',
              message: 'Field is mandatory'
            },
            {
              type: 'minlength',
              message: 'Minimum 8 characters are required',
              params: 8
            },
            {
              type: 'maxlength',
              message: 'Maximum 8 characters are required',
              params: 8
            },
            {
              type: 'pattern',
              params: '^(?!0+$)\\d+$',
              message: 'Invalid value for account number'
            }
          ]"
        >
        </finxone-input>
      </div>
    </div>
    <div *ngIf="!dynamicZone" [ngStyle]="nestedButtonParentCss">
      <finx-button
        type="submit"
        [labeltext]="renderedContent"
        class="nested-button pointer-events-none d-flex"
        [buttonStyle]="!isAllowedGlobalStyling ? submitButtonStyle : {}"
        [class]="isAllowedGlobalStyling ? globalStylingClass : 'w-100'"
        [style.height]="'100%'"
        [class.mandatory-cta-button]="!isAllowedGlobalStyling"
        [isAllowedGlobalStyling]="isAllowedGlobalStyling"
      ></finx-button>
    </div>
  </form>
</div>
